import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    showMenu: false
}

export const showMenuSlice = createSlice({
    name: 'showMenu',
    initialState,
    reducers: {
        toggleShow: (state) => {
            state.showMenu = !state.showMenu
        }
    },
})

export const toggleState = (state) => state.showMenu.showMenu;

export const { toggleShow } = showMenuSlice.actions

export default showMenuSlice.reducer